(function() {
    'use strict';

    angular.module('vobeApp').component('cardCashCombinedDefault', {
        templateUrl: 'app/components/vouchers/card/default/card-cash-combined-default.html',
        controller: 'CardCashCombinedController',
        controllerAs: '$ctrl',
        bindings: {
            viewLayoutTileDesign : '<',//default or text
            tiles: '<', //3 or 4 or 6
            settings: '<',//like vm.settings
            appliedPromotionCode: '<',
            channel: '<',
            //voucherObject: '<',
            voucherPoolObject: '<',
            currentProperty: '<',
            currentPropertyGroup: '<',
            shoppingCart: '<',
            openCashModal: '<',//function
            websiteType: '<',//group or property
            onlyFeatured: '<',
        }
    });
})();
